module.exports = __webpack_public_path__ + "static/media/GPC_vector.d6181db9.svg";